// Angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Rx
import { Observable } from 'rxjs';

// Services
import { AuthService } from 'app/_services';

// Environment
import { environment } from 'environments/environment';

// Models
import { User } from 'app/_models';

// Other
import { JwtHelperService } from '@auth0/angular-jwt';
import * as _ from 'underscore';

const asyncLocalStorage = {
    setItem: function (key, value) {
        return Promise.resolve().then(function () {
            localStorage.setItem(key, value);
        });
    },
    getItem: function (key) {
        return Promise.resolve().then(function () {
            return localStorage.getItem(key);
        });
    }
};

@Component({
    selector: '',
    template: ''
})
export class SignInComponent implements OnInit {
    private jwtHelper: JwtHelperService = new JwtHelperService();
    private refreshSubscription: any;
    private data: Observable<any>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
    ) { }

    ngOnInit() {
        console.log('SignInComponent: ngOnInit');

        const token = this.route.snapshot.queryParams.token;
        let urlParams: any = {};
        let sUrl = '';
        let url: any;
        if (token == null || this.jwtHelper.isTokenExpired(token)) {
            localStorage.removeItem(environment.TokenName);
            localStorage.clear();
            this.router.navigate(['/pages/login']);
        } else {
            let urlQueryParams: any = {};
            const dashboardUrl = '/dashboard';
            const returnUrl: string = localStorage.getItem(environment.ReturnUrlName);

            localStorage.removeItem(environment.ReturnUrlName);

            if (returnUrl && returnUrl.indexOf('?') > 0) {
                url = returnUrl.split('?');

                let entry = '';

                if (url[0].indexOf('purchase/entry') >= 0) {
                    entry = '/purchase/entry';
                } else {
                    entry = url[0];
                }

                urlParams = JSON.parse('{"' + decodeURI(url[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

                sUrl = returnUrl ? entry : dashboardUrl;
            } else {
                sUrl = returnUrl ? returnUrl : dashboardUrl;
            }

            const decodedToken = this.jwtHelper.decodeToken(token);
            const userProfile: User = _.pick(decodedToken, 'tid', 'name', 'given_name', 'family_name', 'unique_name', 'ipaddr');
            userProfile.token = token;

            asyncLocalStorage.setItem(environment.TokenName, JSON.stringify(userProfile)).then(data => {
                this.authService.setAuthenticationProvider('1');

                this.router.navigate([sUrl], { queryParams: urlParams });
            });
        }
    }
}
